import { Component } from "react"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

import { Button } from "../ui-kit/components-branded"

import { TryAgainLater } from "./TryAgainLater"

function AskUserModalView({ children, isOpen, className, onClose, onAccept, title }) {
    return (
        <Modal isOpen={isOpen} className={className} size="lg">
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>{children}</ModalBody>
            <ModalFooter>
                <div className="btn-group" role="group">
                    <Button color="primary" type="button" onClick={onAccept}>
                        Да
                    </Button>
                    <Button type="button" onClick={onClose}>
                        Нет
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

AskUserModalView.defaultProps = {
    className: "ask-user-dialog",
}
class AskUserModal extends Component {
    static View = AskUserModalView

    constructor(props) {
        super(props)
        const askUser = props.askUser === undefined ? true : props.askUser
        this.state = {
            askUser: askUser,
            userAccepted: !askUser,
            modalIsOpen: false,
            showSpinner: props.loading,
        }
    }

    showSpinner = () => {
        this.setState({ showSpinner: true })
    }

    hideSpinner = () => {
        this.setState({ showSpinner: false })
    }

    openModal = () => {
        this.setState({ modalIsOpen: true })
    }

    closeModal = () => {
        this.setState({ modalIsOpen: false })
    }

    onAccept = () => {
        this.setState({ userAccepted: true })
        if (this.props.onAccept) {
            this.props.onAccept()
        }
    }

    onButtonClicked = () => {
        if (!this.state.userAccepted) {
            this.setState({ modalIsOpen: true })
        } else {
            if (this.props.onAccept) {
                this.props.onAccept()
            }
        }
    }

    render() {
        return (
            <>
                {this.state.askUser && !this.state.userAccepted && (
                    <AskUserModalView
                        isOpen={this.state.modalIsOpen}
                        className={this.props.modalClassName}
                        title={this.props.title}
                        onClose={this.closeModal}
                        onAccept={() => {
                            this.closeModal()
                            this.onAccept()
                        }}
                    >
                        {this.props.children}
                    </AskUserModalView>
                )}
                <TryAgainLater
                    ref={this.props.refToButton}
                    tryAgainButtonText={this.props.buttonName}
                    buttonComponent={this.props.buttonComponent}
                    buttonClassEnabled={this.props.buttonClassEnabled}
                    buttonClassDisabled={this.props.buttonClassDisabled}
                    tryAgainFunction={this.onButtonClicked}
                    enabled={this.props.enabled}
                    loading={this.state.showSpinner}
                    resultMessage={this.state.resultMessage}
                    errorMessage={this.state.errorMessage}
                    className={this.props.buttonClasses}
                />
            </>
        )
    }
}

export { AskUserModal }
